import type { PlatformShell } from "./shell.server";

export type { CompareLogoView, LearnEntryView, PlatformShell } from "./shell.server";

/** Whether the root route loaded Drate's own shell (the platform host) rather than a creator's. */
export function isPlatformShell(shell: unknown): shell is PlatformShell {
  return !!shell && typeof shell === "object" && "platform" in shell;
}
